/**
 * Robust Storage Utility for Ganda Sushi
 * 
 * Handles persistent data storage in localStorage with:
 * 1. Versioning and migration support
 * 2. Error handling (try-catch) to prevent data loss
 * 3. Separation from Service Worker Cache Storage
 */

const STORAGE_KEY = 'ganda_favorites_v1';
const VISITED_KEY = 'ganda_visited_before';
const SCHEMA_VERSION = 1;

const migrateData = (data) => {
  if (!data) return [];
  return Array.isArray(data) ? data : [];
};

export const storage = {
  /**
   * Retrieves bookmarked items from localStorage safely
   */
  getBookmarks: () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];

      const parsed = JSON.parse(raw);
      
      if (parsed.version !== SCHEMA_VERSION) {
        const migratedItems = migrateData(parsed.items);
        storage.saveBookmarks(migratedItems);
        return migratedItems;
      }

      return Array.isArray(parsed.items) ? parsed.items : [];
    } catch (error) {
      console.error('Failed to parse bookmarks storage:', error);
      return [];
    }
  },

  /**
   * Saves bookmarked items and sets the visited flag
   */
  saveBookmarks: (items) => {
    try {
      const payload = {
        version: SCHEMA_VERSION,
        updatedAt: new Date().toISOString(),
        items: Array.isArray(items) ? items : []
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      
      // Mark that the user has interacted with favorites
      if (items.length > 0) {
        localStorage.setItem(VISITED_KEY, 'true');
      }
      
      window.dispatchEvent(new Event('storage_update'));
    } catch (error) {
      console.error('Failed to save bookmarks to storage:', error);
    }
  },

  clearBookmarks: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      window.dispatchEvent(new Event('storage_update'));
    } catch (error) {
      console.error('Failed to clear bookmarks:', error);
    }
  },

  /**
   * Checks if the user has ever saved favorites before
   */
  hasVisitedBefore: () => {
    return localStorage.getItem(VISITED_KEY) === 'true';
  }
};